import type { ContentSubmission } from "@/marketing/models/campaignInfluencer";

export interface ContentPostItem {
  url: string;
  sparkAdsCode?: string | undefined;
}

function contentIdentity(rawUrl: string): string {
  try {
    const url = new URL(rawUrl);
    const host = url.hostname.replace(/^www\./, "").toLowerCase();
    if (host === "tiktok.com" || host === "m.tiktok.com") {
      const post = url.pathname.match(/^\/@[^/]+\/video\/(\d+)\/?$/);
      if (post) return `tiktok:${post[1]}`;
    }
    if (host === "instagram.com") {
      const post = url.pathname.match(/^\/(?:p|reel|tv)\/([A-Za-z0-9_-]+)\/?$/);
      if (post) return `instagram:${post[1]}`;
    }
  } catch {
    // Preserve unrecognized submission URLs without guessing their provider identity.
  }
  return rawUrl;
}

// Show each submitted video once without losing its stored metadata.
export function toContentPostItems(
  submissions: ContentSubmission[] | undefined,
): ContentPostItem[] {
  const items: ContentPostItem[] = [];
  const seen = new Set<string>();
  for (const submission of submissions ?? []) {
    const item = { url: submission.url, sparkAdsCode: submission.sparkAdsCode };
    const identity = contentIdentity(item.url);
    if (seen.has(identity)) continue;
    seen.add(identity);
    items.push(item);
  }
  return items;
}
